export const maxLengthConstant = {
  MAX_COUNT_OF_HASHTAGS: 3,
};
